module.exports = __webpack_public_path__ + "static/img/rifle_256.a9b549c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rifle_256.png
// module id = C/rl
// module chunks = 0